module.exports = __webpack_public_path__ + "img/mine_purple.74770e93.png";